import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiWave } from "@/generated/models/ApiWave";
import { BrainView } from "../mobile/brainMobileViews";
import { useWaveTimers } from "@/hooks/useWaveTimers";
type RegisterTabRef = (view: BrainView, el: HTMLButtonElement | null) => void;
interface MyStreamWaveTabsLeaderboardProps {
  readonly wave: ApiWave;
  readonly activeView: BrainView;
  readonly onViewChange: (view: BrainView) => void;
  readonly registerTabRef?: RegisterTabRef | undefined;
  readonly renderAfterLeaderboard?: React.ReactNode;
}
const MyStreamWaveTabsLeaderboard: React.FC<MyStreamWaveTabsLeaderboardProps> = t0 => {
  const $ = _c(16);
  const {
    wave,
    activeView,
    onViewChange,
    registerTabRef,
    renderAfterLeaderboard
  } = t0;
  const {
    voting: t1,
    decisions: t2
  } = useWaveTimers(wave);
  const {
    isCompleted
  } = t1;
  const {
    firstDecisionDone
  } = t2;
  const leaderboardButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-3 tw-py-2 tw-gap-2 tw-flex-1 tw-h-7 tw-rounded-lg ${activeView === BrainView.LEADERBOARD ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const leaderboardButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.LEADERBOARD ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  const winnersButtonClasses = `tw-border-none tw-no-underline tw-flex tw-justify-center tw-items-center tw-px-3 tw-py-2 tw-gap-2 tw-flex-1 tw-h-7 tw-rounded-lg ${activeView === BrainView.WINNERS ? "tw-bg-iron-800" : "tw-bg-iron-950"}`;
  const winnersButtonTextClasses = `tw-font-semibold tw-text-xs sm:tw-text-sm tw-whitespace-nowrap ${activeView === BrainView.WINNERS ? "tw-text-iron-300" : "tw-text-iron-400"}`;
  let t3;
  if ($[0] !== isCompleted || $[1] !== leaderboardButtonClasses || $[2] !== leaderboardButtonTextClasses || $[3] !== onViewChange || $[4] !== registerTabRef) {
    t3 = !isCompleted && <button ref={el => {
      registerTabRef?.(BrainView.LEADERBOARD, el);
    }} onClick={() => onViewChange(BrainView.LEADERBOARD)} className={leaderboardButtonClasses}><span className={leaderboardButtonTextClasses}>Leaderboard</span></button>;
    $[0] = isCompleted;
    $[1] = leaderboardButtonClasses;
    $[2] = leaderboardButtonTextClasses;
    $[3] = onViewChange;
    $[4] = registerTabRef;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== firstDecisionDone || $[7] !== onViewChange || $[8] !== registerTabRef || $[9] !== winnersButtonClasses || $[10] !== winnersButtonTextClasses) {
    t4 = firstDecisionDone && <button ref={el_0 => {
      registerTabRef?.(BrainView.WINNERS, el_0);
    }} onClick={() => onViewChange(BrainView.WINNERS)} className={winnersButtonClasses}><span className={winnersButtonTextClasses}>Winners</span></button>;
    $[6] = firstDecisionDone;
    $[7] = onViewChange;
    $[8] = registerTabRef;
    $[9] = winnersButtonClasses;
    $[10] = winnersButtonTextClasses;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== renderAfterLeaderboard || $[13] !== t3 || $[14] !== t4) {
    t5 = <>{t3}{renderAfterLeaderboard}{t4}</>;
    $[12] = renderAfterLeaderboard;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default MyStreamWaveTabsLeaderboard;